// This file is generated automatically by scripts/generate-icon.js. Don't modify it.

import SoloNew from '../_raw/service/icon_solo_new.svg';
import withIconProps from '../withIconProps';

export default withIconProps(SoloNew);
